import { useParams } from "react-router";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { convertImageNameToWeb } from "../../../helpers/helperFunctions";
import {
  CREDIT_APPROVAL_STATUS,
  CREDIT_HOLD_STATUS,
  CREDIT_REASON,
  CREDIT_TYPE,
} from "../../../helpers/const";
import { Link } from "react-router-dom";
import Button from "../../atoms/Button";
import EmailPopup from "../../atoms/EmailPopup/EmailPopup";
import { getCreditById } from "../../../store/slices/CustomerSlice/CustomerSlice";
import { doInvoiceAction } from "../../../store/slices/OrderSlice/OrderSlice";

export default function CreditDetail() {
  const { id: credit_memo_num } = useParams();
  const [showEmailPopup, setShowEmailPopup] = useState(false);

  const [loadedCredit, setLoadedCredit] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    if (credit_memo_num) {
      dispatch(getCreditById(credit_memo_num)).then((response) => {
        if (response?.payload.credit) {
          setLoadedCredit(response.payload.credit);
        }
      });
    }
  }, [credit_memo_num, dispatch]);

  const handleSendEmail = ({ emails }) => {
    // TODO: Implement credit memo email sending functionality
    let final_emails = [];
    for (let email of emails) {
      final_emails.push({ email: email });
    }
    if (emails && emails.length > 0) {
      // dispatch(sendCreditToClient({
      //   recipients: final_emails,
      //   credit_memo_num: currentCredit,
      // }));
      console.log("Sending credit memo to emails:", final_emails);
    }
    setShowEmailPopup(false);
  };

  const handleDownloadInvoice = (creditMemoNum) => {
    dispatch(
      doInvoiceAction({
        transactionNum: creditMemoNum,
        transactionNumType: "credit",
        deliveryMethod: "pdf",
        emailAddress: "",
        useOverride: false,
        showPricing: true,
      })
    );
  };

  const getStatusBadge = (status) => {
    const statusObj = CREDIT_APPROVAL_STATUS.find(
      (s) => s.id === parseInt(status)
    );

    let badgeClass = "bg-gray-100 text-gray-800";
    if (status === 1) badgeClass = "bg-green-100 text-green-800";
    else if (status === 0) badgeClass = "bg-yellow-100 text-yellow-800";
    else if (status === 2) badgeClass = "bg-blue-100 text-blue-800";

    return (
      <span
        className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${badgeClass}`}
      >
        {statusObj?.label || "Unknown"}
      </span>
    );
  };

  return (
    <>
      {loadedCredit && (
        <main className="relative lg:min-h-full bg-gradient-to-br">
          <div className="mx-auto max-w-2xl px-4 py-16 sm:px-6 sm:py-24 lg:grid lg:max-w-7xl lg:grid-cols-2 lg:gap-x-8 lg:px-4 lg:py-16 xl:gap-x-24">
            <div className="lg:col-start-0">
              <h1 className="text-sm font-medium text-red-600">
                Credit Memo {loadedCredit.credit_memo_num}
                {loadedCredit.customer_invoice_num &&
                  loadedCredit.customer_invoice_num !== "0" &&
                  ` (Invoice ${loadedCredit.customer_invoice_num})`}
              </h1>

              <div className="mt-4 space-y-2">
                <div className="flex justify-between text-sm">
                  <span className="text-gray-600">Status:</span>
                  {getStatusBadge(loadedCredit.status)}
                </div>
                {loadedCredit.date_of_memo &&
                  loadedCredit.date_of_memo !== "0001-01-01" && (
                    <div className="flex justify-between text-sm">
                      <span className="text-gray-600">Date Created:</span>
                      <span className="font-medium">
                        {new Date(
                          loadedCredit.date_of_memo
                        ).toLocaleDateString()}
                      </span>
                    </div>
                  )}
                <div className="flex justify-between text-sm">
                  <span className="text-gray-600">Total Pieces:</span>
                  <span className="font-medium">
                    {loadedCredit.total_pieces}
                  </span>
                </div>
              </div>

              <ul className="mt-6 divide-y divide-gray-200 border-gray-200 text-sm font-medium text-gray-500">
                {loadedCredit.credit_items.map((creditItem, index) => {
                  const item = creditItem.item;
                  return (
                    <li
                      key={item.id || index}
                      className="flex flex-col space-y-4 py-6"
                    >
                      <div className="flex space-x-6">
                        <img
                          alt={item.product_code}
                          src={
                            process.env.REACT_APP_IMAGE_URL +
                            convertImageNameToWeb(`${item.image_name}.jpg`)
                          }
                          className="h-32 w-32 flex-none rounded-md bg-gray-100 object-contain p-2"
                          onError={(e) => {
                            // Prevent infinite loop by only setting default once
                            if (!e.target.src.includes("default.jpg")) {
                              e.target.src =
                                process.env.REACT_APP_IMAGE_URL + "default.jpg";
                            }
                          }}
                        />

                        <div className="flex-auto space-y-1">
                          <h3 className="text-gray-900">
                            <p>{item.description}</p>
                          </h3>
                          <p>
                            ${item?.credit_amount?.toFixed(2) || "-"} x{" "}
                            {item.qty_shipped}
                          </p>
                          <p className="text-red-600 font-medium">
                            Credit Qty: {item.qty_shipped}
                          </p>
                          <p>{item.product_code}</p>
                          <p className="text-xs text-gray-500">
                            Unit Weight: {item.unit_weight} lbs
                          </p>
                          <p className="text-xs text-gray-500">
                            Original Price: ${item?.price?.toFixed(2)}
                          </p>
                        </div>

                        <div className="flex-none text-right">
                          <p className="font-medium text-red-600">
                            {item.credit_amount
                              ? "$" -
                                (
                                  item?.credit_amount * item.qty_shipped
                                ).toFixed(2)
                              : "-"}
                          </p>
                        </div>
                      </div>

                      {/* Render subitems if they exist */}
                      {creditItem.subitems &&
                        creditItem.subitems.length > 0 && (
                          <div className="ml-8 border-l-2 border-gray-200 pl-4">
                            {creditItem.subitems.map((subitem, subIndex) => (
                              <div
                                key={subIndex}
                                className="py-2 text-sm text-gray-600"
                              >
                                <p>{subitem.description || "Subitem"}</p>
                              </div>
                            ))}
                          </div>
                        )}
                    </li>
                  );
                })}
              </ul>
            </div>

            <div className="lg:col-start-2">
              <p className="mt-2 text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl">
                Credit Memo
              </p>

              <div className="lg:flex md:flex mt-8">
                <div>
                  <dt className="font-medium text-gray-900">
                    Credit Information
                  </dt>
                  <dd className="mt-2">
                    <div className="space-y-1">
                      <p className="font-medium">
                        Credit Memo #{loadedCredit.credit_memo_num}
                      </p>
                      <p className="text-sm text-gray-600">
                        Total Items: {loadedCredit.total_pieces}
                      </p>
                      {loadedCredit.customer_invoice_num &&
                        loadedCredit.customer_invoice_num !== "0" && (
                          <p className="text-sm text-gray-600">
                            Invoice: {loadedCredit.customer_invoice_num}
                          </p>
                        )}
                    </div>
                  </dd>
                </div>
              </div>

              {loadedCredit.return_address &&
                (loadedCredit.return_address.name?.trim() ||
                  loadedCredit.return_address.street?.trim()) && (
                  <div className="mt-6">
                    <dt className="font-medium text-gray-900">
                      Return Address
                    </dt>
                    <dd className="mt-2">
                      <address className="not-italic">
                        {loadedCredit.return_address.name?.trim() && (
                          <span className="block">
                            {loadedCredit.return_address.name}
                          </span>
                        )}
                        {loadedCredit.return_address.street?.trim() && (
                          <span className="block">
                            {loadedCredit.return_address.street}
                          </span>
                        )}
                        {loadedCredit.return_address.street_two?.trim() && (
                          <span className="block">
                            {loadedCredit.return_address.street_two}
                          </span>
                        )}
                        {loadedCredit.return_address.locale?.trim() &&
                          loadedCredit.return_address.locale !== " ,    " && (
                            <span className="block">
                              {loadedCredit.return_address.locale}
                            </span>
                          )}
                      </address>
                    </dd>
                  </div>
                )}

              <dl className="space-y-3 mt-6 border-t border-gray-200 pt-4 text-sm font-medium text-gray-500">
                <div className="flex justify-between">
                  <dt>Items Credit</dt>
                  <dd className="text-gray-900">
                    {loadedCredit.total_credit
                      ? `$${loadedCredit.total_credit.toFixed(2)}`
                      : "-"}
                  </dd>
                </div>

                <div className="flex justify-between">
                  <dt>Freight Credit</dt>
                  <dd className="text-gray-900">
                    {loadedCredit.freight_amount
                      ? `$${loadedCredit.freight_amount.toFixed(2)}`
                      : "-"}
                  </dd>
                </div>

                <div className="flex justify-between">
                  <dt>Tariff Amount</dt>
                  <dd className="text-gray-900">
                    {loadedCredit.tariff_amount
                      ? `$${loadedCredit.tariff_amount.toFixed(2)}`
                      : "-"}
                  </dd>
                </div>

                <div className="flex justify-between">
                  <dt>Surcharge</dt>
                  <dd className="text-gray-900">
                    {loadedCredit.surcharge
                      ? `$${loadedCredit.surcharge.toFixed(2)}`
                      : "-"}
                  </dd>
                </div>

                <div className="flex justify-between">
                  <dt>Tax</dt>
                  <dd className="text-gray-900">
                    {loadedCredit.tax ? `$${loadedCredit.tax.toFixed(2)}` : "-"}
                  </dd>
                </div>

                <div className="flex items-center justify-between border-t border-gray-200 pt-6 text-gray-900">
                  <dt className="text-base font-medium">Total Memo Amount</dt>
                  <dd className="text-base font-bold text-red-600">
                    {loadedCredit?.memo_amount
                      ? `-$${loadedCredit.memo_amount.toFixed(2)}`
                      : "-"}
                  </dd>
                </div>
              </dl>

              <div className="mt-6 border-t border-gray-200 py-6 text-right">
                <div className="flex flex-col sm:flex-row gap-4 justify-end items-end">
                  {loadedCredit.customer_invoice_num &&
                  loadedCredit.customer_invoice_num !== "0" ? (
                    <Button
                      textContent="Download Invoice"
                      type="positive"
                      onClick={() =>
                        handleDownloadInvoice(loadedCredit.credit_memo_num)
                      }
                    />
                  ) : (
                    <span className="text-sm text-gray-500 self-center">
                      Invoice not ready
                    </span>
                  )}
                </div>

                <Link
                  to="/view-history"
                  className="inline-block mt-4 text-sm font-medium text-red-600 hover:text-red-800"
                >
                  Back to History
                  <span aria-hidden="true"> &rarr;</span>
                </Link>
              </div>
            </div>

            <EmailPopup
              HeaderText="Credit Memo"
              BodyText="Please enter any email addresses you would like to send the credit memo to."
              cancelFunction={() => setShowEmailPopup(false)}
              dropDownEmails={loadedCredit?.contact?.emails || []}
              onSubmit={handleSendEmail}
              show={showEmailPopup}
            />
          </div>
        </main>
      )}
    </>
  );
}
